<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.address', client.id)">Adres kontrahenta</inertia-link>
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full xl:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <text-input v-model="form.kraj_symbol" :error="form.errors.kraj_symbol" class="pr-6 pb-8 w-full lg:w-1/2" label="Symbol kraju" />
            <text-input v-model="form.wojewodztwo" :error="form.errors.wojewodztwo" class="pr-6 pb-8 w-full lg:w-1/2" label="Województwo" />
            <text-input v-model="form.powiat" :error="form.errors.powiat" class="pr-6 pb-8 w-full lg:w-1/2" label="Powiat" />
            
            <text-input v-model="form.kod_pocztowy" :error="form.errors.kod_pocztowy" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod pocztowy" />
            <text-input v-model="form.miejscowosc" :error="form.errors.miejscowosc" class="pr-6 pb-8 w-full lg:w-1/2" label="Miejscowość" />
            <text-input v-model="form.ulica_lokal" :error="form.errors.ulica_lokal" class="pr-6 pb-8 w-full lg:w-1/2" label="Ulica dom/lokal" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Popraw adres</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'
import axios from 'axios'

export default {
  metaInfo() {
    return { title: 'Zmiana adresu kontrahenta' }
  },
  components: {
    Icon,
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    MultiselectInput
  },
  layout: Layout,
  props: {
    kontrahent: Object,
    client: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        ulica_lokal: this.kontrahent.ULICA_LOKAL,
        kod_pocztowy: this.kontrahent.KOD_POCZTOWY,
        miejscowosc: this.kontrahent.MIEJSCOWOSC,
        wojewodztwo: this.kontrahent.WOJEWODZTWO,
        powiat: this.kontrahent.POWIAT,
        kraj_symbol: this.kontrahent.SYM_KRAJU
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('clients.contractor.address.update', {'client':this.client.id, 'contractor':this.kontrahent.ID_KONTRAHENTA}))
    },
  }

}
</script>